enum Mutation {
  SET_ABSENCES = 'setAbsences',
}

export default Mutation;
